import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        backgroundImage: 'url(/asset/404.jpeg)', 
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <Container className="text-center" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', padding: '50px', borderRadius: '10px' }}>
        <Row>
          <Col>
            <h1 style={{ fontSize: '4rem', marginBottom: '20px', color: '#fff' }}>404</h1>
            <h2 style={{ color: '#fff' }}>Pagină Inexistentă</h2>
            <p style={{ fontSize: '1.2rem', margin: '30px 0', color: '#fff' }}>
              Ne pare rău, dar pagina pe care o cauți nu a fost găsită.
            </p>
            <Button variant="light" size="lg" onClick={() => navigate('/')}>
              Înapoi la Acasă
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NotFound;